export default "__VITE_ASSET__SfjXe_fs__"